import { useQuery } from '@tanstack/react-query';
import { featureFlagV2Keys } from '../featureFlagV2.keys';
import { isFeatureFlagEnabled } from '../featureFlagV2.service';
/**
 * Queries if a feature flag is enabled for a community
 * @param flagKey The feature flag key to check
 * @param subdomain The community subdomain
 * @example ```
 * const { data: isEnabled, isLoading } = useIsFeatureFlagEnabled('new-dashboard', 'zealy');
 * ```
 */
export const useIsFeatureFlagEnabled = (flagKey, subdomain, options = {}) => useQuery({
    queryKey: featureFlagV2Keys.isEnabled(flagKey, subdomain),
    queryFn: () => isFeatureFlagEnabled(flagKey, subdomain),
    ...options,
});
